import EDC from '@/components/games/shared/globals';

/**
 *
 */
// eslint-disable-next-line func-names
EDC.Games.NameSelect.WandRays = function (scene) {
  this.scene = scene;
  this.container = null;
  this.ray1 = null;
  this.ray2 = null;
  this.ray3 = null;
  this.ray4 = null;
  this.isBusy = false;
  return this;
};
/**
 *
 */
EDC.Games.NameSelect.WandRays.prototype.create = function () {
  this.container = this.scene.add.container();
  this.ray1 = this.scene.add.sprite(0, 0, 'name-selection-wand-ray-1');
  this.ray2 = this.scene.add.sprite(0, 0, 'name-selection-wand-ray-2');
  this.ray3 = this.scene.add.sprite(0, 0, 'name-selection-wand-ray-3');
  this.ray4 = this.scene.add.sprite(0, 0, 'name-selection-wand-ray-4');
  this.ray1.setAlpha(0);
  this.ray2.setAlpha(0);
  this.ray3.setAlpha(0);
  this.ray4.setAlpha(0);

  this.container.add([this.ray1, this.ray2, this.ray3, this.ray4]);

  return this;
};
/**
 *
 */
EDC.Games.NameSelect.WandRays.prototype.animate = function () {
  this.scene.tweens.add({
    targets: this.ray1,
    alpha: 1,
    duration: 100, // 300,
    ease: 'Linear',
  });

  this.scene.tweens.add({
    targets: this.ray2,
    alpha: 1,
    // delay: 80,//150,
    duration: 120, // 200,
    ease: 'Linear',
    onComplete: () => {
      this.scene.tweens.add({
        targets: this.ray1,
        alpha: 0,
        duration: 150, // 400,
        ease: 'Linear',
      });
    },
  });

  this.scene.tweens.add({
    targets: this.ray3,
    alpha: 1,
    delay: 100, // 350,
    duration: 150, // 250,
    ease: 'Linear',
    onComplete: () => {
      this.scene.tweens.add({
        targets: this.ray2,
        alpha: 0,
        delay: 0,
        duration: 50, // 200,
        ease: 'Linear',
      });
      this.scene.tweens.add({
        targets: this.ray3,
        alpha: 0,
        duration: 50, // 300,
        ease: 'Linear',
        onComplete: () => {
          this.scene.events.emit(this.scene.gameConfig.signals.S_WAND_RAYS_DONE);
        },
      });
    },
  });
};
/**
 *
 */
EDC.Games.NameSelect.WandRays.prototype.setPosition = function (x, y) {
  this.container.setPosition(x, y);
};
/**
 *
 */
EDC.Games.NameSelect.WandRays.prototype.setScale = function (scale) {
  this.container.setScale(scale);
};

export default EDC.Games.NameSelect.WandRays;
